<template>
  <div id="vMain" v-cloak class="flex flex-d-c global-bg">
    <transition name="fade">
      <div
        class="text-reader"
        v-show="showDialogColorTip"
        @click="switchDialogColorTip"
      >
        <div class="text-body" @click.stop>
          <div class="text-body-title center">实时额度</div>
          <div class="text-body-logo"></div>
          <div class="text-body-text">1.头像为券商的Logo。</div>
          <div class="text-body-text">
            2.红色表示有融资余额，文字表示该券商支持最高的杠杆倍率；灰色表示暂无融资余额；蓝色表示只支持现金打新。
          </div>
          <div class="text-body-text">
            3.额度状态更新可能会存在延迟，请以新股申购提交时为准。
          </div>
          <div class="text-body-button center" @click="switchDialogColorTip">
            知道了
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="text-reader"
        v-show="showDialogRemain"
        @click="switchDialogRemain"
      >
        <div class="text-body" @click.stop>
          <div class="text-body-title center">截止日期</div>
          <div class="text-body-text-remain center">
            各家券商申购截止时间不同，精准时间可在申购页查看。
          </div>
          <div class="text-body-button center" @click="switchDialogRemain">
            知道了
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="text-reader" v-show="showDialog" @click="switchDialog">
        <div class="text-body" @click.stop>
          <div class="text-body-title center">详情</div>
          <div class="text-body-text center">
            将于
            <span v-if="!whichDialogData.rest_time">--</span>
            <span v-else>
              {{
                String(String(whichDialogData.rest_time).split(" ")[0]).split(
                  "-"
                )[1]
              }} </span
            >月
            <span v-if="!whichDialogData.rest_time">--</span>
            <span v-else>
              {{
                String(String(whichDialogData.rest_time).split(" ")[0]).split(
                  "-"
                )[2]
              }} </span
            >日
            <span v-if="!whichDialogData.rest_time">--</span>
            <span v-else>
              {{
                String(String(whichDialogData.rest_time).split(" ")[1]).split(
                  ":"
                )[0]
              }} </span
            >点
            <span v-if="!whichDialogData.rest_time">--</span>
            <span v-else>
              {{
                String(String(whichDialogData.rest_time).split(" ")[1]).split(
                  ":"
                )[1]
              }} </span
            >分放出额度， <span>{{ whichDialogData.multiple }}</span
            >倍杠杆，利率
            <span>{{ whichDialogData.interest_rate }}</span>
            <span>%</span>
          </div>
          <div class="text-body-button center" @click="switchDialog">
            知道了
          </div>
        </div>
      </div>
    </transition>
    <section id="banner" class="card-bg">
      <!--头部导航栏上方信息框-->
      <div class="banner-info-box" @click="jumpToHuiCe">
        <div class="info-box-tip">
          <div class="tip-title">
            <span class="title text-primary">近一年新股表现</span>
            <img
              class="title-icon"
              src="./images/icon_list_forwardNew@3x.png"
              alt="新股表现点击icon"
            />
          </div>
          <span class="sub-title sub-text-gray">了解打新数据</span>
        </div>
        <div class="income-rate">
          <span v-hxmui-redgreen>{{
            ipoData.cumulative_yield ? ipoData.cumulative_yield + "%" : "--"
          }}</span>
          <span class="text-primary">累计收益率</span>
        </div>
        <div class="divide-line"></div>
        <div class="success-rate">
          <span class="text-primary">{{
            ipoData.avg_allocation_rate
              ? ipoData.avg_allocation_rate + "%"
              : "--"
          }}</span>
          <span class="text-primary">平均一手中签率</span>
        </div>
      </div>
      <!--导航栏-->
      <div class="swiper-container swiper-nav">
        <div class="swiper-wrapper nav-wrapper">
          <div
            class="swiper-slide nav-slide"
            v-for="(item, index) in model"
            :key="`o_${index}`"
          >
            <div
              class="nav-item"
              v-for="(nav, index) in item"
              :key="`i_${index}`"
              @click="jumpModel(nav.jump_url, index)"
            >
              <div class="icon">
                <img :src="nav.image_url" alt="导航icon" />
              </div>
              <span class="text-primary">{{ nav.func_name }}</span>
            </div>
          </div>
        </div>

        <!-- Add Pagination -->
        <div class="swiper-pagination nav-pagination"></div>
      </div>
    </section>
    <div class="tab-empty-box" :class="{
        'container-active-linear':
          (isactive === 1 && !availableNone) || isactive === 2,
        'container-active':
          isactive === 0 || isactive === 3 || (availableNone && isactive === 1)}" :style="{ height: emptyBoxHeight + 'px' }">
      <section
        id="tab-container"
        :class="{
        'container-active-linear':
          (isactive === 1 && !availableNone) || isactive === 2,
        'container-active':
          isactive === 0 || isactive === 3 || (availableNone && isactive === 1),
        'tab-fixed-ipo': tabShow && isInIpo(),
        'tab-fixed-notIpo': tabShow && !isInIpo(),
      }"
      >
        <Segment
          v-if="segment"
          :segmentItem="segment"
          :tabsList="tabButton"
          @change="handleTabChange"
        />
        <div
          v-show="tabShow && deliveredTitle"
          class="flex jc-sb delivered-title card-bg sub-text-gray"
        >
          <div class="company">公司名称</div>
          <!-- todo 已递表状态暂时隐藏 -->
          <!-- <div class="state">状态</div> -->
          <div class="date">申请日期</div>
        </div>
      </section>
    </div>
    <section
      id="table-body"
      class="flex-1"
      ref="tableBody"
      v-show="whichTab === '可认购'"
    >
      <div v-if="!availableNone">
        <section id="tab-panel" class="global-bg">
          <div
            class="tab-card-container"
            v-for="(item, index) in available"
            :key="index"
          >
            <!--卡片-->
            <div class="tab-panel-card card-bg">
              <!--卡片头部，包括股票名以及代码-->
              <div class="card-row-one">
                <div class="card-name">
                  <span class="card-stock-name text-primary">{{
                    handleStockName(item.stock_name)
                  }}</span>
                  <span class="card-stock-code text-desc"
                    >({{ item.stock_code.slice(2) }})</span
                  >
                  <div v-if="false" class="card-right-tip">
                    <span class="right-icon-tip text-desc">查看详情</span>
                    <img
                      src="./images/icon_list_forwardNew@3x.png"
                      alt="可认购卡片点击icon"
                    />
                  </div>
                </div>
              </div>
              <!--分割线-->
              <div class="divide-line"></div>
              <!--招股价-->
              <div class="card-two-section-one flex jc-sb ai-c">
                <div class="card-key text-sub">招股价</div>
                <div class="card-value ff-ths text-primary">
                  <span>{{ item.issue_price_internal || "--" }}</span>
                </div>
              </div>
              <!--入场费-->
              <div class="card-two-section-one flex jc-sb ai-c">
                <div class="card-key text-sub">入场费</div>
                <div class="card-value text-primary">
                  <span class="ff-ths">{{ item.admission || "--" }}</span>
                  <span class="card-value-unit" v-if="item.admission">HKD</span>
                </div>
              </div>
              <!--认购倍数-->
              <div class="card-two-section-one flex jc-sb ai-c">
                <div class="card-key text-sub">认购倍数</div>
                <div class="card-value ff-ths text-primary">
                  {{ item.real_time_subscription_rate || "--"
                  }}<span
                    v-if="item.real_time_subscription_rate"
                    class="card-value-unit"
                    >倍</span
                  >
                </div>
              </div>
              <!-- todo 同股上市表现数据有歧义，暂不展示-->
              <!-- <div class="card-two-section-one flex jc-sb ai-c">
                <div class="card-key text-sub">同行上市表现</div>
                <div class="card-value ff-ths text-primary">
                  <span class="card-value-zn" v-if="item.industry_uplift_rate"
                    >首日上涨概率</span
                  >
                  <span>{{
                    item.industry_uplift_rate
                      ? item.industry_uplift_rate + "%"
                      : "--"
                  }}</span>
                </div>
              </div> -->
              <!--券商优惠活动-->
              <div
                v-if="item.qs_activity_labels.length"
                class="card-two-section-one flex jc-sb ai-c"
              >
                <div class="card-key text-sub">券商优惠活动</div>
                <div
                  class="card-value flex tag-box"
                  @click="showActivityPopup(item.stock_code)"
                >
                  <div class="flex">
                    <div
                      class="card-tag"
                      :key="index"
                      v-for="(item, index) in item.qs_activity_labels.slice(
                        0,
                        2
                      )"
                    >
                      {{ item }}
                    </div>
                  </div>
                  <img
                    class="tag-arrow"
                    src="./images/icon_list_forwardNew@3x.png"
                    alt="右箭头"
                  />
                </div>
              </div>
              <!--分割线-->
              <div class="divide-line"></div>
              <!--卡片底部申购按钮-->
              <div class="card-bottom">
                <div class="card-bottom-left">
                  <div class="rest-time text-primary">
                    <CountDown
                      class="count-down"
                      :time-str="item.stop_subscription_date"
                    ></CountDown>
                    <span
                      v-if="!isReachTime(`${item.stop_subscription_date}`)"
                      class="info"
                      @click="switchDialogRemain()"
                    ></span>
                  </div>
                  <span class="time-tip text-sub"
                    >{{ item.stop_subscription_date }} 认购截止</span
                  >
                </div>
                <div v-if="false" class="card-bottom-right" @click="handleBuyClick(item)">
                  {{
                    isReachTime(`${item.stop_subscription_date}`)
                      ? "去查看"
                      : "申购"
                  }}
                </div>
              </div>
            </div>
            <!--广告-->
            <div
              class="tab-panel-ad"
              v-if="item.add_content"
              @click="stockAdClick(item.add_url, index)"
            >
              <img
                class="ad-left-icon"
                src="./images/icon_yunying@3x.png"
                alt=""
              />
              <span class="panel-ad-content text-sub">{{
                item.add_content
              }}</span>
              <img
                class="ad-link-icon"
                src="./images/icon_list_forwardNew@3x.png"
                alt="广告点击icon"
              />
            </div>
          </div>
          <div class="available-bottom">
            <div class="jump-button flex ai-c jc-c" @click="jumpToHuiCe">
              点击了解港股打新
            </div>
            <div class="risk-tips">{{ getDisclaimer() }}</div>
          </div>
        </section>
      </div>
      <div class="available-none card-bg" v-else>
        <div class="view-none"></div>
        <div v-if="!hideBuyBtn" class="view-none-button flex ai-c jc-c" @click="jumpAccount()">
          立即开户 备战明星股
        </div>
      </div>
    </section>
    <div class="delivered flex-1" v-show="whichTab === '已递表'">
      <div v-if="deliveredHasData === true">
        <div class="flex delivered-title sub-text-gray">
          <div class="company">公司名称</div>
          <!-- todo 已递表状态暂时隐藏 -->
          <!-- <div class="state">状态</div> -->
          <div class="date">申请日期</div>
        </div>
        <div id="delivered-table">
          <div
            class="delivered-body flex"
            v-for="(item, index) in delivered"
            :key="index"
          >
            <div class="company-name text-primary">{{ item.company }}</div>
            <!-- todo 已递表状态暂时隐藏 -->
            <!-- <div class="company-state text-primary">正在处理</div> -->
            <div class="company-date text-primary">
              {{ item.application_date }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="deliveredHasData === false"
        class="none-data text-primary flex-1"
      >
        暂无数据
      </div>
    </div>
    <div
      id="to-belisted"
      class="flex-1 global-bg"
      v-show="whichTab === '待上市'"
    >
      <div class="belist-body" v-if="belistedHasData === true">
        <ToBeListedCard
          @click="jumpAvalible(item)"
          v-for="item in toBeListedNew"
          :key="item.stock_code"
          :item="item"
          :hide-btn="hideBuyBtn"
          class="to-be-listed-card"
          @success="handleBuyClick(item)"
        ></ToBeListedCard>
      </div>
      <div v-else class="none-data flex-1">
        <span class="text-primary">暂无数据</span>
      </div>
    </div>
    <div
      v-show="whichTab === '已上市'"
      id="listed"
      class="flex flex-d-c flex-1"
    >
      <div v-if="listedHasData === true" class="has-data flex-1 card-bg">
        <stock-list
          :list="listedNew"
          fixed="left"
          menu-height="1rem"
          :expand="true"
        >
          <stock-list-item
            prop="stock_name"
            label="名称代码"
            :label-width="stockNameWidth"
          >
            <tempalte v-slot="scope">
              <div class="flex flex-d-c stock-item" style="height: 0.82rem">
                <div class="name text-primary">{{ scope.stock_name }}</div>
                <div class="flex info-box">
                  <div class="hk flex ai-c jc-c">HK</div>
                  <div class="ff-ths code">{{ scope.stock_code.slice(2) }}</div>
                </div>
              </div>
            </tempalte>
            <template v-slot:menu="scope">
              <div
                :style="{ width: stockExpandWidth }"
                class="menu flex jc-a ai-c global-bg text-primary"
                @click.stop
              >
                <div class="flex ai-c jc-c" @click="jumpClient(scope)">
                  <span class="anpan"></span>查看行情
                </div>
                <div
                  class="flex ai-c jc-c"
                  @click="jumpAvalible(scope)"
                  v-if="scope.issue_display == 1"
                >
                  <span class="available-data"></span>发行资料
                </div>
                <div
                  class="flex ai-c jc-c"
                  @click="jumpResult(scope)"
                  v-if="scope.placement_display == 1"
                >
                  <span class="result"></span>配售结果
                </div>
              </div>
            </template>
          </stock-list-item>
          <stock-list-item
            prop="listing_date"
            label="上市日期"
            :label-width="stockItemWidth"
            :sortable="true"
          >
            <tempalte v-slot="scope">
              <div class="remark stock-item">
                <p
                  class="ff-ths text-primary"
                  style="
                    height: 0.82rem;
                    text-align: right;
                    font-size: 0.3rem;
                    line-height: 0.82rem;
                  "
                >
                  {{ scope.listing_date || "--" }}
                </p>
              </div>
            </tempalte>
          </stock-list-item>
          <stock-list-item
            prop="first_day_gain"
            label="首日涨跌幅"
            :label-width="stockItemWidth"
            :sortable="true"
          >
            <tempalte v-slot="scope">
              <div
                class="ff-ths stock-item"
                :class="getNumberCss(scope.first_day_gain)"
                style="
                  height: 0.82rem;
                  text-align: right;
                  font-size: 0.3rem;
                  line-height: 0.82rem;
                "
              >
                {{ scope.first_day_gain | numfilter }}
              </div>
            </tempalte>
          </stock-list-item>
          <stock-list-item
            prop="gray_pct_change"
            label="暗盘涨跌幅"
            :label-width="stockItemWidth"
            :sortable="true"
          >
            <tempalte v-slot="scope">
              <div class="remark stock-item">
                <p
                  class="ff-ths"
                  :class="getNumberCss(scope.gray_pct_change)"
                  style="
                    height: 0.82rem;
                    text-align: right;
                    font-size: 0.3rem;
                    line-height: 0.82rem;
                  "
                >
                  {{ formatPercent(scope.gray_pct_change) }}
                </p>
              </div>
            </tempalte>
          </stock-list-item>
          <stock-list-item
            prop="latest"
            label="最新价"
            :label-width="stockItemWidth"
            :sortable="true"
          >
            <tempalte v-slot="scope">
              <div
                class="ff-ths stock-item"
                style="
                  height: 0.82rem;
                  text-align: right;
                  font-size: 0.3rem;
                  line-height: 0.82rem;
                "
              >
                <span
                  v-if="scope.latest"
                  :class="getNumberCss(scope.latest - scope.issue_price)"
                  >{{ scope.latest }}</span
                >
                <span v-else class="text-black">--</span>
              </div>
            </tempalte>
          </stock-list-item>
          <stock-list-item
            prop="issue_price"
            label="发行价"
            :label-width="stockItemWidth"
            :sortable="true"
          >
            <tempalte v-slot="scope">
              <div class="remark">
                <p
                  class="ff-ths text-primary"
                  style="
                    height: 0.82rem;
                    text-align: right;
                    font-size: 0.3rem;
                    line-height: 0.82rem;
                  "
                >
                  {{ formatPrice(scope.issue_price, 3) }}
                </p>
              </div>
            </tempalte>
          </stock-list-item>
          <stock-list-item
            prop="gain_since_listed"
            label="上市至今涨幅"
            :label-width="stockItemWidth"
            :sortable="true"
          >
            <tempalte v-slot="scope">
              <div class="remark stock-item">
                <p
                  class="ff-ths"
                  :class="getNumberCss(scope.latest - scope.issue_price)"
                  style="
                    height: 0.82rem;
                    text-align: right;
                    font-size: 0.3rem;
                    line-height: 0.82rem;
                  "
                >
                  {{ scope.gain_since_listed || "--" }}
                </p>
              </div>
            </tempalte>
          </stock-list-item>
        </stock-list>
      </div>
      <div v-else class="none-data flex-1 card-bg text-primary">暂无数据</div>
    </div>

    <!-- 活动列表 -->
    <CustomPopup
      title="券商优惠活动"
      :is-show="activityPopupShow"
      @close="activityPopupShow = false"
      @overlay-click="activityPopupShow = false"
    >
      <ActivityItem
        @click="handleActivityItemClick(act)"
        :item="act"
        class="my-activity-item"
        v-for="act in activityList"
        :key="act.qsid"
      ></ActivityItem>
    </CustomPopup>

    <!-- 券商列表 -->
    <CustomPopup
      title="选择证券账户"
      :is-show="brokerPopupShow"
      @close="brokerPopupShow = false"
      @overlay-click="brokerPopupShow = false"
    >
      <div class="popup-sub-title">已开通券商</div>
      <BrokerItem
        @click="jumpOpenTest('4',broker,true)"
        :item="broker"
        class="my-activity-item"
        v-for="broker in brokerList"
        :key="broker.qsId"
      ></BrokerItem>
    </CustomPopup>
  </div>
</template>

<script>
import Vue from "vue";
import initAddress from "./common/config.js";
import {
  Display,
  StockList,
  StockListItem,
} from "./common/index_components.js";
import {
  ajax,
  getAccount,
  stopBodyScroll,
  handleStockName,
  __getMarketInfo,
  jumpIpoVersion,
  jumpIpoAction,
  openTest
} from "./common/utils.js";
import { iosExamine, androidGmgTradeHide, } from './common/examine.js';
import ToBeListedCard from "./components/ToBeListedCard";
import CountDown from "./components/CountDown";
import CustomPopup from "./components/CustomPopup";
import ActivityItem from "./components/ActivityItem";
import BrokerItem from "./components/BrokerItem";
import Segment from "@/components/segment/index.vue";
import "swiper/dist/css/swiper.css";

Vue.use(Display).use(StockList).use(StockListItem);
const param = window.getParam();
export default {
  name: "HkStock", // 机构持股页
  components: {
    ToBeListedCard,
    CountDown,
    CustomPopup,
    ActivityItem,
    BrokerItem,
    Segment,
  },
  data() {
    return {
      availableNumber: "",
      showDialogColorTip: false,
      showDialogRemain: false,
      whichDialogData: {},
      tabButton: [
        {
          title: "已递表",
          name: "delivered",
          index: 0,
        },
        {
          title: "可认购",
          name: "available",
          index: 1,
        },
        {
          title: "待上市",
          name: "tobelist",
          index: 2,
        },
        {
          title: "已上市",
          name: "listed",
          index: 3,
        },
      ],
      isactive: -1,
      segment: "",
      whichTab: "", // 切换的tab
      deliveredHasData: true, // 已递表表格是否有数据
      belistedHasData: true, // 待上市表格是否有数据
      listedHasData: true, // 已上市表格是否有数据
      availableNone: true, // 可认购是否有数据
      offsetTop: "",
      tabShow: false,
      deliveredTitle: false,
      listedTitle: false,
      belisted: [], // 待上市
      delivered: [], // 已递表
      listed: [], // 已上市
      available: [], // 可认购
      pageNumber: 0,
      stockCode: "",
      deliveredLock: false, // 已递表请求加锁
      avalibleLock: false, // 可认购请求加锁
      listedLock: false, // 已上市请求加锁
      toBeListedLock: false, // 待上市请求加锁
      stockCodeList: [],
      marketList: [],
      toBelistStockList: [],
      toBeListedMarketList: [],
      lastestData: [],
      bannerModelLock: false,
      banner: [],
      model: [],
      deliveredScroll: 0,
      availableScroll: 0,
      toBeListedScroll: 0,
      listedScroll: 0,
      url_ver: "SJCGBS-24354",
      lastestStock: [],
      //loop: true,
      hideOnClick: false,
      fun: null,
      zhangdie: [],
      showDialog: false,
      displayInfo: [],
      list: [],
      toBeListedNew: [], // 新待上市数据
      listedNew: [], // 新已上市数据
      listedNewOrderLock: false, // 已上市初次请求锁
      listedNewScrollLock: false, // 已上市滚动加载请求锁
      listedOrderNumber: 0, // 已上市请求页码
      listOrder: "0", // 当前排序方式
      listColumnName: "first_day_gain", // 当前排序列表
      hexinSC: true, // 是否是手抄
      apiAdvData: [], // mobilehub广告位数据
      activityPopupShow: false,
      brokerPopupShow: false,
      ipoData: {
        cumulative_yield: "",
        avg_allocation_rate: "",
      },
      activityList: [],
      brokerList: [],
      wholeBrokerList: [],
      isShare:
        !window.F10Utils.getBroker() &&
        window.F10Utils.getUrlParams("fromshare"), // 是否是分享出去的页面
      scrollTop: {
        delivered: 0,
        tobelist: 0,
        listed: 0,
        available: 0,
      },
      //空盒子高度
      emptyBoxHeight: 60,
      //qsId->新股申购配置接口返回数据
      gmg_trade_obj:{},
      //判断是否使用灰度
      changerStatus:false,
      //用户使用的设备
      plateForm:window.getPlatform(),
      // 隐藏申购按钮
      hideBuyBtn: false,
    };
  },
  created() {
    // 因为使用的公司内部的theme的样式class，这些class的黑夜模式区分安卓与苹果端
    // 但是黑夜模式只有一套苹果端，所以将安卓手机的黑夜模式的型号设为iphone
    document.querySelector("html").setAttribute("theme-platform", "iphone");
    initAddress();
  },
  watch: {
    gmg_trade_obj:{
      handler(nv){
        if(nv.is_test && nv.is_test.toString()==='true'){
          openTest().then(data=>{
            this.changerStatus = data;
          });
        }
      },
      deep:true,
    },
    model() {
      this.$nextTick(() => {
        this.initNavSwiper();
      });
    },
  },
  computed: {
    blockHeight() {
      if (this.isInIpo()) {
        const domBlock = document.getElementById("hkStock-calendar-block-ipo");
        return domBlock ? domBlock.getBoundingClientRect().height : 0;
      }
      return 0;
    },
    stockNameWidth() {
      const clientWidth = document.body.clientWidth;
      if (clientWidth > 375) {
        return `${(2.54 * (clientWidth / 375)).toFixed(2)}rem`;
      }
      return "2.54rem";
    },
    stockItemWidth() {
      const clientWidth = document.body.clientWidth;
      if (clientWidth > 375) {
        return `${(1.84 * (clientWidth / 375)).toFixed(2)}rem`;
      }
      return "1.84rem";
    },
    stockExpandWidth() {
      const clientWidth = document.body.clientWidth;
      if (clientWidth > 375) {
        return `${(7.5 * (clientWidth / 375)).toFixed(2)}rem`;
      }
      return "7.5rem";
    },
    tabTop() {
      return window.$("#tab-container").offset().top - this.blockHeight;
    },
  },
  async mounted() {
    //获取新股申购地址配置
    this.getGmgTradeConfig();
    this.getIPOData();
    this.getBannerModel();
    this.touchBottom();
    const that = this;
    if (window.getPlatform() === "gphone") {
      this.hideBuyBtn = await this.androidGmgTradeHide();
      window.registerWebListener("onShow", function () {
        window.webHQData.disWebHQ();
        that.$nextTick(() => {
          that.getLastestData();
        });
      });
    } else {
      this.hideBuyBtn = this.iosExamine();
      document.addEventListener("visibilitychange", function () {
        that.debounce(that.res, 0);
      });
    }
    window.hxmPageStat("free_gangmeiipo", {
      url_ver: this.url_ver,
    });
    // 获取可认购数据
    this.getAvailableNew();
    // 根据url参数显示对应当前tab页面
    this.init();
    this.getTabScrollHeight();
    this.getDeliveredInit();
    // 获取待上市数据
    this.getBelistedNew();

    setTimeout(() => {
      this.$nextTick(() => {
        // 新已上市数据
        setTimeout(() => {
          this.getOffset(100);
          this.fixed(this.offsetTop);
        });
      });
    }, 100);
    //获取完整的券商列表
    this.getWholeBrokerList();
    this.$nextTick(() => {
      this.emptyBoxHeight = $("#tab-container").offset().height;
    })
  },
  filters: {
    numfilter(val) {
      if (isNaN(parseFloat(val))) {
        return "--";
      } else {
        return val;
      }
    },
  },
  methods: {
    iosExamine,
    androidGmgTradeHide,
    /**
     * 灰度跳转逻辑 target=1
     * target=1时代表用户没登陆记录，
     */
    jumpOpenTestOne(){
      if(this.changerStatus){
        if(this.plateForm==='gphone'){
          window.location.href = 'client.html?action=ymtz^webid=21600^MaskID=bTBwNzRha2Y3Yg';
        }else{
          window.location.href = 'client.html?action=ymtz^webid=2901^MaskID=bTBwNzRha2Y3Yg';
        }
      }else{
        jumpIpoAction();
      }
    },
    /**
     * 灰度跳转逻辑 target=2
     * target=2代表有当前在线账号且当前使用的券商支持直接跳转新股申购
     */
    jumpOpenTestTwo(detailObj){
      if(this.changerStatus){
        window.location.href = `client.html?action=ymtz^webid=2804^url=${detailObj.url}?marketId=${detailObj.marketId}&stockCode=${detailObj.stockCode}&fromPage=true`;
      }else{
        jumpIpoAction(detailObj);
      }
    },
    /**
     * 灰度跳转逻辑 target=3
     * target=3代表有当前在线账号且当前使用的券商不支持直接跳转新股申购
     */
    jumpOpenTestThree(otherParams,detailObj){
      if(this.changerStatus){
        if(this.plateForm==='gphone'){
          window.location.href = `client.html?action=ymtz^webid=21600^${otherParams}`;
        }else{
          window.location.href = `client.html?action=ymtz^webid=2901^${otherParams}`;
        }
      }else{
        this.handleBrokerItemClick(detailObj);
      }
    },
    /**
     * 灰度跳转逻辑 target=4
     * target=4代表有登陆记录却无在线账号
     */
    jumpOpenTestFour(otherParams,detailObj,disLogin){
      if(this.changerStatus){
        if(this.plateForm==='gphone'){
          window.location.href = `client.html?action=ymtz^webid=21600^${otherParams}`;
        }else{
          window.location.href = `client.html?action=ymtz^webid=2901^${otherParams}`;
        }
      }else{
        this.handleBrokerItemClick(detailObj,disLogin);
      }
    },
    /**
     * 灰度跳转逻辑
     * @param target 判断执行哪种跳转逻辑的指标
     * target=1时代表用户没登陆记录，
     * target=2代表有当前在线账号且当前使用的券商支持直接跳转新股申购
     * target=3代表有当前在线账号且当前使用的券商不支持直接跳转新股申购
     * target=4代表有登陆记录却无在线账号
     */
    jumpOpenTest(target,detailObj,disLogin){
      window.hxmJumpNativeStat('free_gangmeiipo.shengou', '', {
        url_ver: 'SJCGBS-29951',
      });
      const otherParams =
        detailObj.online === '1'
          ? ''
          : `qsId=${detailObj.qsId}^wtId=${detailObj.wtId}^account=${detailObj.account}`;
      switch(target) {
        case '1':
          this.jumpOpenTestOne();
          break;
        case '2':
          this.jumpOpenTestTwo(detailObj);
          break;
        case '3':
          this.jumpOpenTestThree(otherParams,detailObj);
          break;
        case '4':
          this.jumpOpenTestFour(otherParams,detailObj,disLogin);
          break;
        default:
          this.jumpOpenTestOne();
          break;
      }
    },
    /**
     * 获取新股申购跳转地址
     */
    getGmgTradeConfig(){
      $.ajax({
        url: window.gmg_trade_Url,
        type: 'GET',
        timeout: 3000,
        success: res => {
          if(Number(res.status_code) === 0 && res.data && res.data.conf_content){
            this.gmg_trade_obj = JSON.parse(res.data.conf_content);
          }
        },
        error: error => {
          console.log(error);
        },
      });
    },
    /**
     * 是否到达指定时间
     * @param timeStr 指定的时间
     */
    isReachTime(timeStr) {
      const curTime = Date.now();
      //开始时间,解决ios不能解析带有-的时间字符串
      const startTime = new Date(timeStr.replace(/-/g, "/")).getTime();
      return curTime > startTime;
    },

    /**
     *处理股票名称
     */
    handleStockName(name) {
      return handleStockName(name);
    },

    /**
     *根据数字（百分数或小数）字符串获取css
     * @param str 百分数或小数
     * @return css类
     */
    getNumberCss(str) {
      const num = parseFloat(str);
      if (num > 0) {
        return "text-red";
      } else if (num < 0) {
        return "text-green";
      }
      return "text-black";
    },

    /**
     * 给定一个小数转为百分数
     * @param num 小数
     * @return 百分数或'--'
     */
    handleDecimalToPercentage(num) {
      //如果数正常且为又穷数
      if (num && isFinite(num)) return `${(num * 100).toFixed(2)}%`;
      else if (num === 0) return "0.00%";
      return "--";
    },

    /**
     * 格式化价格
     * @param str 价格字符串
     * @param digit 几位小数
     */
    formatPrice(str, digit) {
      const num = parseFloat(str);
      if (!isNaN(num)) return Number(str).toFixed(digit);
      return "--";
    },

    /**
     * 格式化不带%的百分数
     * @param str 数字字符串
     * @return 百分数字符串
     */
    formatPercent(str) {
      if (str) {
        const num = parseFloat(str);
        if (num !== 0) {
          return `${num.toFixed(2)}%`;
        }
        return "0.00%";
      }
      return "--";
    },

    /**
     * 跳转至回测中心
     */
    jumpToHuiCe() {
      // 分享出去的页面点击后跳转下载同花顺
      if (this.handlePageToThs()) {
        return;
      }
      window.F10Utils.jumpToLink({
        url: window._hxmFormatUrl(window.huice_url),
      });
      window.hxmJumpPageStat(`free_gangmeiipo.ipohuice`, "", {
        url_ver: "SJCGBS-28531",
      });
    },

    /** 获取完整的券商列表（带有券商头像和券商名） */
    async getWholeBrokerList() {
      //只有在第一次时请求
      const brokerData = await ajax(
        "get",
        window.basic_prefix_api + window.prefix_center + "/list/brokers"
      );
      if (
        brokerData.status_code === 0 &&
        brokerData.status_code === 0 &&
        brokerData.data &&
        brokerData.data.list &&
        brokerData.data.list.length > 0
      ) {
        this.wholeBrokerList = brokerData.data.list;
      }
    },

    /** 点击申购 */
    async handleBuyClick(item) {
      // 分享出去的页面点击后跳转下载同花顺
      if (this.handlePageToThs()) {
        return;
      }
      //通过客户端协议获取用户绑定的券商
      const data = await getAccount();
      //如果没有绑定券商，跳转
      if (data.accountList.length === 0) {
        const sendOriginStat = ()=>{
          hxmJumpNativeStat('free_gangmeiipo.shengou', '', {
            url_ver: 'SJCGBS-29951',
          });
        };
        //跳转券商区分安卓和ios
        switch(jumpIpoVersion()) {
          case 'android_newVersion':
            this.jumpOpenTest('1',{});
            break;
          case 'android_oldVersion':
            sendOriginStat();
            window.location.href = 'client.html?action=ymtz^webid=21600^MaskID=bTBwNzRha2Y3Yg';
            break;
          case 'ios_newVersion':
            this.jumpOpenTest('1',{});
            break;
          case 'ios_oldVersion':
            sendOriginStat();
            window.location.href = 'client.html?action=ymtz^webid=2901^MaskID=bTBwNzRha2Y3Yg';
            break;
          default:
            break;
        }
        return;
      }
      //券商列表不为空，过滤并且组装完整用户绑定的券商数据
      this.brokerList = this.getWholeBrokerInfo(
        this.wholeBrokerList,
        data.accountList
      );
      //过滤出登录的账号并且按登录时间排序，登录晚的排排前面
      const onlineList = this.brokerList.filter(item => item.online === '1').sort((a, b) => b.selectTime - a.selectTime);
      let jumpParam;
      //如果有登录的账号直接跳转
      if (onlineList.length !== 0) {
        jumpParam = {
          url:this.gmg_trade_obj[onlineList[0].qsId],
          marketId:item.market_code,
          stockCode:item.stock_code,
          qsId:onlineList[0].qsId,
          wtId:onlineList[0].wtId,
          account:onlineList[0].account,
          online:onlineList[0].online,
        };
        if(this.gmg_trade_obj[onlineList[0].qsId] && onlineList[0].online === '1'){
          this.jumpOpenTest('2',jumpParam);
        }else{
          this.jumpOpenTest('3',jumpParam);
        }
      } else {
        if (this.brokerList.length === 1) {
          this.brokerList[0].url = this.gmg_trade_obj[this.brokerList[0].qsId];
          this.brokerList[0].marketId = item.market_code;
          this.brokerList[0].stockCode = item.stock_code;
          //如果登录账户为个数0，且绑定的券商只有一个，直接弹窗进行登录
          this.jumpOpenTest('4',this.brokerList[0],true);
        } else {
          //如果没有登录弹列表窗
          this.brokerList.forEach(list=>{
            list.marketId = item.market_code;
            list.stockCode = item.stock_code;
            list.url = this.gmg_trade_obj[list.qsId];
          });
          this.brokerPopupShow = true;
        }
      }
    },

    /**
     * 组装完整的券商信息
     * @param brokerList 完整券商列表
     * @param accountList 用户绑定的券商账户
     * @return list 添加券商头像和券商名的新账户列表
     */
    getWholeBrokerInfo(brokerList, accountList) {
      const list = [];
      for (const account of accountList) {
        for (const broker of brokerList) {
          if (account.qsId === broker.qsid) {
            account.qsname = broker.qsname;
            account.qslogo = broker.qslogo;
            list.push({ ...account });
            break;
          }
        }
      }
      return list;
    },

    /**
     * 获取券商活动列表
     * @param stock_code 股票代码
     */
    getActivityList(stock_code) {
      window.$.ajax({
        url:
          window.basic_prefix_api +
          window.prefix_center +
          "/list/available/activities",
        data: {
          stock_code,
        },
        timeout: 3000,
        success: (res) => {
          if (
            res.status_code === 0 &&
            res.data &&
            res.data.list &&
            res.data.list.length > 0
          ) {
            this.activityList = res.data.list;
          }
        },
      });
    },

    /**
     *股票广告点击跳转
     * @param url 跳转地址
     * @param index 索引
     */
    stockAdClick(url, index) {
      const number = index + 1;
      window.F10Utils.jumpToLink({
        url: window._hxmFormatUrl(url),
      });

      window.hxmJumpPageStat(`free_gangmeiipo.banner.${number}`, "", {
        url_ver: "SJCGBS-28531",
      });
    },

    /** 获取统计数据 */
    async getIPOData() {
      const res = await ajax(
        "get",
        window.basic_prefix_api + window.prefix_center + "/list/overview"
      );
      if (res.data && res.status_code === 0) {
        this.ipoData.cumulative_yield = res.data.cumulative_yield;
        this.ipoData.avg_allocation_rate = res.data.avg_allocation_rate;
      }
    },

    /**
     *点击券商列表项的立即申购进行跳转
     * @param broker 券商
     */
    handleBrokerItemClick(broker,disLogin) {
      //如果登录则直接跳转2091，不带参数；如果未登录则携带参数，进行弹框
      const otherParams =
        broker.online === "1"
          ? ""
          : `qsId=${broker.qsId}^wtId=${broker.wtId}^account=${broker.account}`;
      switch(jumpIpoVersion()) {
        case 'android_newVersion':
          jumpIpoAction(broker,disLogin);
          break;
        case 'android_oldVersion':
          window.location.href = `client.html?action=ymtz^webid=21600^${otherParams}`;
          break;
        case 'ios_newVersion':
          jumpIpoAction(broker,disLogin);
          break;
        case 'ios_oldVersion':
          window.location.href = `client.html?action=ymtz^webid=2901^${otherParams}`;
          break;
        default:
          break;
      }
    },

    /**
     *处理活动点击进行跳转
     * @param act
     */
    handleActivityItemClick(act) {
      window.F10Utils.jumpToLink({
        url: window._hxmFormatUrl(act.acti_url),
      });
    },

    /**
     *点击股票卡片显示popup
     * @param stock_code 股票代码
     */
    showActivityPopup(stock_code) {
      //每次点击时清空
      this.activityList = [];
      this.getActivityList(stock_code);
      //获取券商活动列表
      window.hxmClickStat("free_gangmeiipo.krg.huodongopen", {
        url_ver: "SJCGBS-28531",
      });
      this.activityPopupShow = true;
    },

    /** 初始化导航swiper */
    initNavSwiper() {
      const navSwiper = new window.Swiper(".swiper-nav", {
        pagination: {
          el: ".swiper-pagination",
        },
        observer: true,
        observeParents: true,
      });
    },

    isHexin() {
      //判断是否是港美通
      const u = navigator.userAgent;
      const gphoneIndex = u.indexOf("Hexin_HKUSGphone/");
      const iphoneIndex = u.indexOf("IHexinHKUS/");
      if (gphoneIndex > -1) {
        this.hexinSC = false;
      } else if (iphoneIndex > -1) {
        this.hexinSC = false;
      } else {
        this.hexinSC = true;
      }
    },

    // 新的可认购请求
    getAvailableNew() {
      window.$.ajax({
        url: window.basic_prefix_api + window.prefix_center + "/list/available",
        timeout: 3000,
        success: (res) => {
          try {
            if (res.status_code === 0) {
              this.availableNone = false;
              if (res.data.stock_list.length !== 0) {
                this.available = res.data.stock_list;
                this.availableNumber = res.data.stock_list.length;
                this.available.map((item) => {
                  item.real_time_quota_list.map((url) => {
                    const a = url.logo_url.replace(/^(http)[s]?[:]/i, "");
                    this.$set(url, "logo_url", a);
                  });
                });
              } else {
                this.availableNone = true;
              }
            } else {
              this.availableNone = true;
            }
          } catch (error) {
            this.availableNone = true;
          }
        },
        error: () => {
          this.availableNone = true;
        },
      });
    },
    // 已上市滚动发送请求
    getListScroll() {
      if (this.listedNewScrollLock) {
        return;
      }
      this.listedNewScrollLock = true;
      window.$.ajax({
        url:
          window.basic_prefix_api + window.prefix_center + "/get_listed_stocks",
        dataType: "json",
        type: "GET",
        data: {
          page_number: this.listedOrderNumber,
          order: this.listOrder,
          field: this.listColumnName,
        },
        success: (res) => {
          try {
            this.listedNewScrollLock = false;
            if (res.status_code === 0) {
              Array.prototype.push.apply(this.listedNew, res.data.listed);
              this.$nextTick(() => {
                this.listedNew.map((item) => {
                  this.$set(item, "expand", false);
                  this.stockCodeList.push(item.stock_code);
                  this.marketList.push(item.stock_market);
                });
              });
              this.listedNew.push(1);
              this.listedNew.pop(1);
              this.getLastestData();
              this.$forceUpdate();
            } else {
              this.listedHasData = false;
            }
            if (res.data.page_status === 1) {
              this.listedNewScrollLock = true;
              return;
            }
          } catch (error) {
            this.listedNewScrollLock = true;
            this.listedHasData = false;
          }
        },
        error: () => {
          this.listedNewScrollLock = true;
          this.listedHasData = false;
        },
      });
    },
    // 点击排序发送的请求
    getOrderList(order, columnName) {
      if (this.listedNewOrderLock) {
        return;
      }
      this.listedNewOrderLock = true;
      this.listedNewScrollLock = false; // 滚动加载解锁
      // 已上市数组是否需要初始化
      const tableOrder = order === true ? "0" : "1"; // 判断升序降序
      this.listOrder = tableOrder;
      this.listColumnName = columnName;
      this.listedOrderNumber = 0;
      // 首日涨幅，客户端取值
      // 其他情况后端取值
      window.$.ajax({
        url:
          window.basic_prefix_api + window.prefix_center + "/get_listed_stocks",
        dataType: "json",
        type: "GET",
        data: {
          page_number: this.listedOrderNumber,
          order: tableOrder,
          field: columnName,
        },
        success: (res) => {
          try {
            this.listedNewOrderLock = false;
            if (res.status_code === 0) {
              this.$nextTick(() => {
                if (res.data.listed.length === 0) {
                  this.listedHasData = false;
                  return;
                }
                this.listedNew = res.data.listed || [];
                this.listedNew.map((item) => {
                  this.$set(item, "expand", false);
                  this.stockCodeList.push(item.stock_code);
                  this.marketList.push(item.stock_market);
                });
                this.getLastestData();
                this.$forceUpdate();
              });
            } else {
              this.listedHasData = false;
            }
          } catch (error) {
            this.listedHasData = false;
            this.listedNewOrderLock = true;
          }
        },
        error: () => {
          this.listedHasData = false;
          this.listedNewOrderLock = true;
        },
      });
    },

    // 获取新待上市数据
    getBelistedNew() {
      window.$.ajax({
        url:
          window.basic_prefix_api + window.prefix_center + "/list/to_be_listed",
        dataType: "json",
        type: "GET",
        cache: false,
        success: (res) => {
          try {
            if (res.status_code === 0) {
              if (res.data.stock_list.length === 0) {
                this.belistedHasData = false;
              }
              this.toBeListedNew = res.data.stock_list || [];
              this.getMarketInfo();
            } else {
              this.getMarketInfo();
              this.belistedHasData = false;
            }
          } catch (error) {
            this.getMarketInfo();
            this.belistedHasData = false;
          }
        },
        error: () => {
          this.getMarketInfo();
          this.belistedHasData = false;
        },
      });
    },

    getMarketInfo() {
      //股票代码数组
      const stockCodeList = [];
      //股票市场id数组
      const marketIdList = [];
      //组装获取市场信息所需要的数组
      this.toBeListedNew.forEach((item) => {
        stockCodeList.push(item.stock_code);
        marketIdList.push(`${item.stock_market}`);
      });
      this.toBelistStockList = stockCodeList;
      this.toBeListedMarketList = marketIdList;
      // 已上市数据默认排序取值
      this.getOrderList(false, "listing_date");
    },

    /**
     * 处理市场信息，将返回的所需参数添加到stockList的对象上
     * @param newPriceList 最新价
     * @param changePercentList 涨跌幅
     */
    handleMarketInfo(newPriceList, changePercentList) {
      const { toBeListedNew } = this;
      for (let i = 0; i < toBeListedNew.length; i++) {
        //通过$set将新增的属性变为响应式
        this.$set(this.toBeListedNew[i], "newPrice", newPriceList[i]);
        this.$set(this.toBeListedNew[i], "changePercent", changePercentList[i]);
      }
    },

    // 实时额度
    switchDialogColorTip() {
      this.showDialogColorTip = !this.showDialogColorTip;
      stopBodyScroll();
      if (this.showDialogColorTip) {
        window.hxmClickStat("free_gangmeiipo.edujieshi", {
          url_ver: this.url_ver,
        });
        window.$("body").css("position", "fixed");
      } else {
        this.$nextTick(() => {
          window.$("body").css("position", "static");
        });
      }
    },
    // 剩余天数
    switchDialogRemain() {
      this.showDialogRemain = !this.showDialogRemain;
      stopBodyScroll();
      if (this.showDialogRemain) {
        window.hxmClickStat("free_gangmeiipo.shijianjiezhi", {
          url_ver: this.url_ver,
        });
        window.$("body").css("position", "fixed");
      } else {
        this.$nextTick(() => {
          window.$("body").css("position", "static");
        });
      }
    },
    // 券商等待状态点击弹窗
    switchDialog(ob) {
      this.showDialog = !this.showDialog;
      stopBodyScroll();
      if (this.showDialog) {
        this.whichDialogData = ob;
        window.hxmClickStat("free_gangmeiipo.dengdai", {
          url_ver: this.url_ver,
        });
        window.$("body").css("position", "fixed");
      } else {
        this.$nextTick(() => {
          window.$("body").css("position", "static");
        });
      }
    },
    /**
     * 跳转分时页面
     * @param {object} 股票公司信息
     */
    jumpClient(item) {
      window.hxmJumpNativeStat("free_gangmeiipo.yss.fenshi", "", {
        url_ver: this.url_ver,
        stock_code: this.stockCode,
      });
      // 分享出去的页面点击后跳转下载同花顺
      if (this.handlePageToThs()) {
        return;
      }
      window.location.href =
        "client.html?action=ymtz^webid=2205^stockcode=" +
        item.stock_code +
        "^marketid=" +
        item.stock_market +
        "^tabid=14";
    },
    /**
     * 获取已递表和已上市的的scroll高度
     */
    getTabScrollHeight() {
      this.deliveredScroll = this.tabTop;
      this.listedScroll = this.tabTop;
      this.availableScroll = this.tabTop;
      this.toBeListedScroll = this.tabTop;
    },

    /**
     * 跳转开户
     */
    jumpAccount() {
      window.hxmJumpPageStat("free_gangmeiipo.kaihu", "", {
        url_ver: this.url_ver,
      });
      // 分享出去的页面点击后跳转下载同花顺
      if (this.handlePageToThs()) {
        return;
      }
      const jumpUrl =
        "//eq.10jqka.com.cn/download/UsBrokersList/index.html?MaskID=bTBwNzRha2Y3Yg";
      window.F10Utils.jumpToLink({
        url: jumpUrl,
      });
    },

    /**
     * 宫格跳转
     * @param url  跳转地址
     * @param index 第几个九宫格
     */
    jumpModel(url, index) {
      // 分享出去的页面点击后跳转下载同花顺
      if (this.handlePageToThs()) {
        return;
      }
      const number = index + 1;
      if (url.includes("client")) {
        window.location.href = url;
      } else {
        window.F10Utils.jumpToLink({
          url: window._hxmFormatUrl(url),
        });
      }
      window.hxmJumpPageStat("free_gangmeiipo.gongge." + number, "", {
        url_ver: this.url_ver,
      });
    },
    /**
     * 获取banner、九宫格图片地址以及跳转链接
     */
    getBannerModel() {
      if (this.bannerModelLock) {
        return;
      }
      this.bannerModelLock = true;
      window.$.ajax({
        type: "POST",
        url: window.basic_prefix_api + window.prefix_header,
        data: {},
        timeout: 3000,
        dataType: "json",
        success: (res) => {
          this.bannerModelLock = false;
          this.isHexin();
          try {
            if (this.hexinSC) {
              const param = {
                type: ["gmgxingubanner"],
              };
              window.businessGetresdatajs.getResData(
                param,
                (data) => {
                  if (data && data.data.gmgxingubanner) {
                    data.data.gmgxingubanner.map((item) => {
                      this.apiAdvData.push({
                        id: item.id,
                        banner_url: item.imgurl,
                        jump_url: item.jumpurl,
                      });
                    });
                    this.banner = this.apiAdvData;
                    if (this.banner.length === 1) {
                      //this.loop = false;
                      this.hideOnClick = false;
                    } else {
                      //this.loop = true;
                      this.hideOnClick = true;
                    }
                  } else {
                    window.$("#top").css("display", "none");
                  }
                },
                () => {
                  window.$("#top").css("display", "none");
                }
              );
            } else {
              this.banner = res.data.banner;
              if (this.banner.length === 1) {
                //this.loop = false;
                this.hideOnClick = false;
              } else {
                //this.loop = true;
                this.hideOnClick = true;
              }
            }
          } catch (error) {
            console.log(error);
          }
          this.model = this.handleModel(res.data.model);
          if (this.model.length === 0) {
            window.$("#banner").css("display", "none");
          }
        },
        error: () => {
          this.bannerModelLock = true;
          if (this.model.length === 0) {
            window.$("#banner").css("display", "none");
          }
        },
      });
    },

    /**
     * 处理model
     * @param arr 数组
     */
    handleModel(arr) {
      let tmp = [];
      const res = [];
      for (let i = 1; i < arr.length + 1; i++) {
        tmp.push(arr[i - 1]);
        if (i % 5 === 0) {
          res.push([...tmp]);
          tmp = [];
        }
      }
      //如果最后tmp里面有子项
      if (tmp.length > 0) {
        res.push([...tmp]);
      }
      return res;
    },

    /**
     * 分页页面加载时机
     */
    touchBottom() {
      window.$(window).on("scroll", () => {
        if (this.whichTab === "已递表") {
          this.deliveredScroll = this.getDocumentTop();
        }
        if (this.whichTab === "可认购") {
          this.availableScroll = this.getDocumentTop();
        }
        if (this.whichTab === "待上市") {
          this.toBeListedScroll = this.getDocumentTop();
        }
        if (this.whichTab === "已上市") {
          this.listedScroll = this.getDocumentTop();
        }
        if (
          this.getScrollHeight() <
          this.getDocumentTop() + this.getWindowHeight() + 100
        ) {
          if (this.whichTab === "已递表" && this.deliveredLock === false) {
            this.pageNumber = this.pageNumber + 1;
            this.getHasTenderedTable();
          } else if (this.whichTab === "可认购") {
            window.hxmOnceStat("free_gangmeiipo.bottom", {
              url_ver: this.url_ver,
            });
          }
        }
      });
    },
    /** 文档高度 */
    getDocumentTop() {
      let scrollTop = 0;
      let bodyScrollTop = 0;
      let documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop =
        bodyScrollTop - documentScrollTop > 0
          ? bodyScrollTop
          : documentScrollTop;
      return Number(scrollTop);
    },

    /**
     * 可视窗口高度
     */
    getWindowHeight() {
      let windowHeight = 0;
      if (document.compatMode === "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return Number(windowHeight);
    },
    /**
     * 获取上市港股最新价
     */
    getLastestData() {
      window.webHQData.initWebHQ(
        {
          columOrder: ["4", "10", "34818"],
          stockList: [...this.stockCodeList, ...this.toBelistStockList],
          marketList: [...this.marketList, ...this.toBeListedMarketList],
        },
        (lastest) => {
          const allLen = lastest[10].length;
          const toBeListedLen = this.toBeListedMarketList.length;
          const newPriceList = lastest[10].slice(
            allLen - toBeListedLen,
            allLen
          );
          const changePercentList = lastest[34818].slice(
            allLen - toBeListedLen,
            allLen
          );
          this.handleMarketInfo(newPriceList, changePercentList);
          this.lastestData = lastest[10].slice(0, allLen - toBeListedLen);
          this.lastestStock = lastest[4].slice(0, allLen - toBeListedLen);
          this.zhangdie = lastest[34818].slice(0, allLen - toBeListedLen);
          this.lastestData.map((item) => {
            if (
              item === undefined ||
              item === "" ||
              item == null ||
              item === "undefined"
            ) {
              item = "--";
            }
          });
          this.$nextTick(() => {
            //如果获取的数据不完全，则重新从通过客户端协议取
            if (this.listedNew.length !== this.zhangdie.length) {
              this.stockCodeList = [];
              this.marketList = [];
              this.listedNew.map((list) => {
                this.stockCodeList.push(list.stock_code);
                this.marketList.push(list.stock_market);
              });
              this.getLastestData();
              return;
            }
            const listedDataOld = [].concat(this.listedNew);
            //处理最新价
            for (let i = 0; i < this.listedNew.length; i++) {
              listedDataOld[i].latest =
                this.lastestData[
                  this.lastestStock.indexOf(this.listedNew[i].stock_code)
                ];
            }
            //处理上市至今涨跌幅
            for (let i = 0; i < this.listedNew.length; i++) {
              listedDataOld[i].gain_since_listed =
                this.handleDecimalToPercentage(
                  (listedDataOld[i].latest - listedDataOld[i].issue_price) /
                    listedDataOld[i].issue_price
                );
            }
            for (let i = 0; i < this.listedNew.length; i++) {
              if (listedDataOld[i].flag_today === "1") {
                listedDataOld[i].first_day_gain =
                  this.zhangdie[
                    this.lastestStock.indexOf(this.listedNew[i].stock_code)
                  ];
              }
            }
            this.listedNew = listedDataOld;
            if (this.listOrder === "0" && this.listColumnName === "latest") {
              this.listedNew.sort((a, b) => {
                return Number(a.latest) - Number(b.latest);
              });
            } else if (
              this.listOrder === "1" &&
              this.listColumnName === "latest"
            ) {
              this.listedNew.sort((a, b) => {
                return Number(b.latest) - Number(a.latest);
              });
            }
            if (this.listColumnName === "latest") {
              let deleteItem = {};
              this.listedNew.map((item, index) => {
                if (item.latest === "--") {
                  deleteItem = item;
                  this.listedNew.splice(index, 1);
                  this.listedNew.push(deleteItem);
                }
              });
            }
            this.$forceUpdate();
          });
        }
      );
    },
    /**
     * 滚动条滚动高度
     */
    getScrollHeight() {
      let scrollHeight = 0;
      let bodyScrollHeight = 0;
      let documentScrollHeight = 0;
      if (document.body) {
        bodyScrollHeight = document.body.scrollHeight;
      }
      if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight;
      }
      scrollHeight =
        bodyScrollHeight - documentScrollHeight > 0
          ? bodyScrollHeight
          : documentScrollHeight;
      return Number(scrollHeight);
    },
    /**
     * 跳转配售结果页
     * @param {*} item
     */
    jumpResult(item) {
      // 分享出去的页面点击后跳转下载同花顺
      if (this.handlePageToThs()) {
        return;
      }
      const url = `${window.result_api}?stockCode=${item.stock_code}&stockName=${item.stock_name}`;
      window.F10Utils.jumpToLink({
        url: window._hxmFormatUrl(url),
      });
    },
    /**
     * 跳转认购资料页
     */
    jumpAvalible(item) {
      // 分享出去的页面点击后跳转下载同花顺
      if (this.handlePageToThs()) {
        return;
      }
      if (this.whichTab === "可认购") {
        const labels = item.qs_activity_labels;
        this.stockCode = item.stock_code;
        let url;
        // 如果隐藏申购按钮，跳转到二级页面，取消from参数
        if (this.hideBuyBtn) {
          url = `${window.page_url}?stockCode=${item.stock_code}&labelone=${labels[0] || ""}&labeltwo=${labels[1] || ""}`;
        } else {
          url = `${window.page_url}?stockCode=${item.stock_code}&from=${
          this.whichTab
        }&labelone=${labels[0] || ""}&labeltwo=${labels[1] || ""}`;
        }
        window.F10Utils.jumpToLink({
          url: window._hxmFormatUrl(url),
        });
        window.hxmJumpPageStat("free_gangmeiipo.krg.xiangqing", "", {
          url_ver: this.url_ver,
          targid: item.stock_code,
        });
      } else {
        if (this.whichTab === "待上市") {
          window.hxmJumpPageStat("free_gangmeiipo.dss.xiangqing", "", {
            url_ver: this.url_ver,
            targid: item.stock_code,
          });
        }
        const url = `${window.page_url}?stockCode=${item.stock_code}&from=${this.whichTab}`;
        window.F10Utils.jumpToLink({
          url: window._hxmFormatUrl(url),
        });
      }
    },

    /**
     * 获取可认购数据
     */
    getAvailable() {
      // 请求加锁
      if (this.avalibleLock) {
        return;
      }
      this.avalibleLock = true;
      window.$.ajax({
        type: "POST",
        url: window.basic_prefix_api + window.prefix_api + "/available",
        data: {},
        timeout: 3000,
        dataType: "json",
        success: (res) => {
          if (res.status_code === 0) {
            if (res.data.available.length === 0) {
              this.availableNone = true;
            } else {
              this.availableNone = false;
              this.available = res.data.available;
            }
          } else {
            this.availableNone = true;
          }
          this.avalibleLock = false;
        },
        error: () => {
          this.avalibleLock = false;
          this.availableNone = true;
        },
      });
    },
    /**
     *获取初始已递表数据
     */
    getDeliveredInit() {
      if (this.deliveredLock) {
        return;
      }
      this.deliveredLock = true;
      window.$.ajax({
        type: "POST",
        url:
          window.basic_prefix_api +
          window.prefix_api +
          "/delivered" +
          `?pageNumber=${this.pageNumber}`,
        data: {},
        timeout: 3000,
        dataType: "json",
        success: (res) => {
          // 请求错误，显示没有数据
          if (res.status_code === 1) {
            this.deliveredLock = true;
            this.deliveredHasData = false;
            return;
          }
          // 请求正确，但是没有初始数据
          if (res.status_code === 0 && res.data.delivered.length === 0) {
            this.deliveredLock = true;
            this.deliveredHasData = false;
            return;
          }
          this.deliveredLock = false;
          this.deliveredHasData = true;
          this.delivered = res.data.delivered;
          // 正确请求，下一页没有数据
          if (res.status_code === 0 && res.data.page_status === 1) {
            this.deliveredLock = true;
          }
        },
        error: () => {
          this.deliveredLock = false;
          this.deliveredHasData = false;
        },
      });
    },
    /**
     * 获取待上市数据
     */
    getBelisted() {
      if (this.toBeListedLock) {
        return;
      }
      this.toBeListedLock = true;
      window.$.ajax({
        type: "POST",
        url: window.basic_prefix_api + window.prefix_api + "/toBeListed",
        data: {},
        timeout: 3000,
        dataType: "json",
        success: (res) => {
          this.toBeListedLock = false;
          if (res.data.to_be_listed.length !== 0) {
            this.belistedHasData = true;
            this.belisted = res.data.to_be_listed;
          } else {
            this.belistedHasData = false;
          }
        },
        error: () => {
          this.toBeListedLock = false;
          this.belistedHasData = false;
        },
      });
    },
    /**
     * 获取已递表表格数据
     */
    getHasTenderedTable() {
      if (this.deliveredLock) {
        return;
      }
      this.deliveredLock = true;
      window.$.ajax({
        type: "POST",
        url:
          window.basic_prefix_api +
          window.prefix_api +
          "/delivered" +
          `?pageNumber=${this.pageNumber}`,
        data: {},
        timeout: 3000,
        dataType: "json",
        success: (res) => {
          // 请求超出页码,禁止再发送请求
          if (res.data.page_status === 1) {
            this.deliveredLock = true;
            return;
          }
          this.deliveredLock = false;
          this.$nextTick(() => {
            Array.prototype.push.apply(this.delivered, res.data.delivered);
            this.$forceUpdate();
          });
          // 正确请求数据，没有下一页数据
          if (res.data.status_code === 0 && res.data.page_status === 1) {
            this.deliveredLock = true;
            return;
          }
        },
        error: () => {
          this.deliveredLock = false;
        },
      });
    },

    /**
     * tab吸顶
     * @param {number} num tab距离顶部的距离
     */
    fixed(num) {
      num = Number(num);
      this.$nextTick(() => {
        window.$(window).on("scroll", () => {
          let scrollT = window.$(window).scrollTop() + this.blockHeight;
          scrollT = Number(scrollT);
          if (scrollT >= num) {
            this.$nextTick(() => {
              this.tabShow = true;
              if (this.whichTab === "已递表") {
                this.deliveredTitle = true;
              }
              this.listedTitle = this.whichTab === "待上市";
            });
          } else if (scrollT < num) {
            this.$nextTick(() => {
              this.tabShow = false;
              this.deliveredTitle = false;
              this.listedTitle = false;
            });
          }
        });
      });
    },

    /**
     * 获取tab切换时应该的滚动距离
     * @param distance 距离
     */
    getScrollDistance(distance) {
      return distance > this.tabTop ? distance : this.tabTop + 1;
    },

    /**
     * 切换tab获取数据
     * @param {string} item 选中的tab数组的数据
     */
    handleTabChange(item) {
      this.whichTab = item.title;
      this.isactive = item.index;
      this.deliveredTitle = false;
      this.listedTitle = false;
      if (this.whichTab === "可认购") {
        if (this.tabShow) {
          window.scrollTo(0, this.getScrollDistance(this.availableScroll));
        }
        window.hxmClickStat("free_gangmeiipo.kerengou", {
          url_ver: this.url_ver,
        });
      } else if (this.whichTab === "待上市") {
        this.listedTitle = true;
        if (this.tabShow) {
          window.scrollTo(0, this.getScrollDistance(this.toBeListedScroll));
        }
        window.hxmClickStat("free_gangmeiipo.daishangshi", {
          url_ver: this.url_ver,
        });
      } else if (this.whichTab === "已上市") {
        this.deliveredTitle = false;
        if (this.tabShow) {
          window.scrollTo(0, this.getScrollDistance(this.listedScroll));
        }
        window.hxmClickStat("free_gangmeiipo.yishangshi", {
          url_ver: this.url_ver,
        });
        // this.touchBottom()
      } else if (this.whichTab === "已递表") {
        this.listedTitle = false;
        this.deliveredTitle = true;
        if (this.tabShow) {
          window.scrollTo(0, this.getScrollDistance(this.deliveredScroll));
        }
        this.deliveredHasData = this.delivered.length !== 0;
        window.hxmClickStat("free_gangmeiipo.ydb", {
          url_ver: this.url_ver,
        });
      }
    },
    /**
     * 获取#tab的offsettop相对于视窗顶部距离
     * @param {number} n 延迟时间
     */
    getOffset(n) {
      setTimeout(() => {
        this.$nextTick(() => {
          const top = Number(this.tabTop);
          this.deliveredScroll = top;
          this.listedScroll = top;
          this.availableScroll = top;
          this.toBeListedScroll = top;
          this.offsetTop = window.$("#tab-container").offset().top;
          if (this.offsetTop !== 0) {
            this.fixed(this.offsetTop);
            return;
          } else {
            this.getOffset(n);
          }
        });
      }, n);
    },
    // 防抖
    debounce(fn, wait) {
      if (this.fun !== null) {
        clearTimeout(this.fun);
      }
      this.fun = setTimeout(fn, wait);
    },
    // 分时页回退再获取此客户端最新价
    res() {
      window.webHQData.disWebHQ();
      this.$nextTick(() => {
        this.getLastestData();
      });
    },
    // 通过传参数控制显示tab
    init() {
      let whichTab;
      try {
        whichTab = window.getParam("whichTab");
      } catch (error) {
        console.log(error);
      }
      if (whichTab) {
        if (whichTab === "delivered") {
          this.segment = "delivered";
          this.whichTab = "已递表";
          this.isactive = 0;
        } else if (whichTab === "tobelist") {
          this.segment = "tobelist";
          this.whichTab = "待上市";
          this.isactive = 2;
        } else if (whichTab === "listed") {
          this.segment = "listed";
          this.whichTab = "已上市";
          this.isactive = 3;
        } else {
          this.segment = "available";
          this.whichTab = "可认购";
          this.isactive = 1;
        }
      } else {
        this.segment = "available";
        this.whichTab = "可认购";
        this.isactive = 1;
      }
    },
    // 是否在F10打新日历页面
    isInIpo() {
      const hash = window.location.hash;
      if (hash.indexOf("hkStock") > -1) {
        return !Number(window.F10Utils.getUrlParams("isNotShowTab"));
      }
    },
    // 返回免责协议
    getDisclaimer() {
      const disclaimer = window.F10Utils.getDisclaimer();
      if (disclaimer && disclaimer.content) {
        return disclaimer.content;
      }
      return "";
    },
    // 分享后点击和客户端协议有关的按钮跳转下载同花顺客户端
    handlePageToThs() {
      if (this.isShare) {
        // 模拟用户点击回流组件
        const dom = document.getElementsByClassName("openBtn");
        if (dom.length > 0) {
          dom[0].click();
        }
        return true;
      }
      return false;
    },
  },
};
</script>
<style lang="less">
@import "./style/basic.css";
@import "./style/common.less";
@import "./style/index_components.less";
@import "./style/swiper.css";
@import "./style/banner.less";
@import "./style/index.less";
@import "./style/index.less";
</style>
